import * as React from "react";
import { DataGrid, GridColDef, GridRenderCellParams, GridValueGetterParams } from "@mui/x-data-grid";
import { imageUrl } from "../../../../services/Constants";
import * as DepartmentManagementActions from "../../../../actions/departmentmanagement.action";
import * as menuconfigActions from "../../../../actions/menuconfig.action";
import * as requestDeleteActions from "../../../../actions/request.delete.actions";
import { useDispatch, useSelector } from "react-redux";
import { RootReducers } from "../../../../reducers";
import {
    Stack,
    IconButton,
    Typography,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    CardContent,
    Card,
    TextField
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../..";
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { server, TOKEN } from "../../../../services/Constants";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { blue, red } from "@mui/material/colors";
import "./DepartmentManagement.css";
import { Search as SearchIcon } from "@mui/icons-material";
import Container from '@mui/material/Container';
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import MenuItem from "@mui/material/MenuItem";
import Menu, { MenuProps } from "@mui/material/Menu";
import * as loginActions from "../../../../actions/login.action";
// import SearchBar from "material-ui-search-bar";
// const CustomToolbar = (props:any) => {
//     return (
//         <Box>
//             <Grid>
//                 <SearchBar {...props} />
//             </Grid>
//         </Box>
//     )
// }



interface QuickSearchToolbarProps {
    clearSearch: () => void;
    onChange: () => void;
    value: string;
}


type DepartmentManagementProps = {
  //
};

const DepartmentManagement: React.FC<any> = () => {
  const DepartmentManagementStateReducer = useSelector((state: RootReducers) => state.DepartmentManagementStateReducer);
  const menuconfigReducer = useSelector((state: RootReducers) => state.menuconfigStateReducer);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [selectedDepartmentManagement, setSelectedDepartmentManagement] = React.useState<any>({});
  const [openDialog, setOpenDialog] = React.useState<boolean>(false);
  const [dataAddDepartmentManagement, setdataAddDepartmentManagement] = React.useState({name:""});
  const [dataEditDepartmentManagement, setdataEditDepartmentManagement] = React.useState({id:0,name:""});
  
  const [openaddDepartmentManagement, setOpenaddDepartmentManagement] = React.useState(false);
  const [openeditDepartmentManagement, setOpeneditDepartmentManagement] = React.useState(false);

  const Alllanguages = [
    {
      code: 'en',
      name: 'English'
    },
    {
      code: 'th',
      name: 'Thai'
    }
  ];

  const handleAddDepartmentManagement = () => {
    setdataAddDepartmentManagement({name:""})
    console.log("add");
    setOpenaddDepartmentManagement(true);
};

const handleEditDepartmentManagement = (data:any) => {
    setdataEditDepartmentManagement({id:data.id,name:data.name});
    console.log("edit");
    setOpeneditDepartmentManagement(true);
};


  const handleCloseaddDepartmentManagement = () => {
    setOpenaddDepartmentManagement(false);
  };

  const handleCloseeditDepartmentManagement = () => {
    setOpeneditDepartmentManagement(false);
  };

  const handleAddDepartmentManagementSubmit = (event:any) => {
    event.preventDefault();
    console.log("SubmitAdd");
    dispatch(
        DepartmentManagementActions.addDepartmentManagement(
            dataAddDepartmentManagement,
          navigate
        )
      );
  };
  const handleEditDepartmentManagementSubmit = (event:any) => {
    event.preventDefault();
    console.log("SubmitEdit");
    dispatch(
        DepartmentManagementActions.editDepartmentManagement(
            dataEditDepartmentManagement,
          navigate
        )
      );
  };

  React.useEffect(() => {
    if (DepartmentManagementStateReducer.isAdddata) {
        Swal.fire({
            title: `${t("Information Saved")}`,
            text: `${t("The information has been saved and updated successfully.")}`,
            icon: "success",
          });
          setOpenaddDepartmentManagement(false);
          dispatch(DepartmentManagementActions.setDepartment_ManagementFetchingToState());
          dispatch(DepartmentManagementActions.loadDepartment_Management());
      return;
    } else if(DepartmentManagementStateReducer.isAddError) {
        Swal.fire({
            title: `${t("Information Saved")}`,
            text: `${t("The information has been saved and updated unsuccessfully.")}`,
            icon: "error",
          });
          setOpenaddDepartmentManagement(false);
        dispatch(DepartmentManagementActions.setDepartment_ManagementFetchingToState());
        dispatch(DepartmentManagementActions.loadDepartment_Management());
     
    }else if(DepartmentManagementStateReducer.isEditdata) {
        Swal.fire({
            title: `${t("Information Saved")}`,
            text: `${t("The information has been saved and updated successfully.")}`,
            icon: "success",
          });
          setOpeneditDepartmentManagement(false);
        dispatch(DepartmentManagementActions.setDepartment_ManagementFetchingToState());
        dispatch(DepartmentManagementActions.loadDepartment_Management());
     
    }else if(DepartmentManagementStateReducer.isEditError) {
        Swal.fire({
            title: `${t("Information Saved")}`,
            text: `${t("The information has been saved and updated unsuccessfully.")}`,
            icon: "error",
          });
          setOpeneditDepartmentManagement(false);
        dispatch(DepartmentManagementActions.setDepartment_ManagementFetchingToState());
        dispatch(DepartmentManagementActions.loadDepartment_Management());
     
    }
    
    else if(DepartmentManagementStateReducer.isDeletedata) {
        Swal.fire({
          title: `${t("Information Saved")}`,
          text: `${t("The information has been saved and updated successfully.")}`,
            icon: "success",
          });
        dispatch(DepartmentManagementActions.setDepartment_ManagementFetchingToState());
        dispatch(DepartmentManagementActions.loadDepartment_Management());
     
    }else if(DepartmentManagementStateReducer.isDeleteError) {
        Swal.fire({
          title: `${t("Information Saved")}`,
          text: `${t("The information has been saved and updated unsuccessfully.")}`,
            icon: "error",
          });
        dispatch(DepartmentManagementActions.setDepartment_ManagementFetchingToState());
        dispatch(DepartmentManagementActions.loadDepartment_Management());
     
    }else {
    }
  }, [DepartmentManagementStateReducer]);
  
 

  //load data table
  React.useEffect(() => {
    if (!localStorage.getItem(TOKEN)) {
      dispatch(loginActions.logouttologinpage(navigate));
    }
    dispatch(menuconfigActions.getMENU_CONFIGCheckRouteConfigmenu(window.location.pathname.replace("/", "").split("/")[0],navigate));
      dispatch(DepartmentManagementActions.loadDepartment_Management());
      
      // menuconfigReducer
  }, []);

  React.useEffect(() => {

  }, [DepartmentManagementStateReducer]);

  const requestColumns: GridColDef[] = [
      {
          headerName: `${t('ID')}`,
          field: "id",
          flex: 1,
          minWidth: 50
      },
      {
          headerName: `${t('Department Name')}`,
          field: "name",
          flex: 1,
          minWidth: 200
      },
      
      // {
      //     headerName: "",
      //     field: ".",
      //     maxWidth: 150,
      //     align: "center",
      //     renderCell: ({ row }: GridRenderCellParams<string>) => (
      //         <Stack direction="row">
      //             <IconButton
      //                 aria-label="edit"
      //                 size="large"
      //                 onClick={() => {
      //                   handleEditDepartmentManagement(row);
      //                 }}
      //         >
      //                 <EditIcon 
      //                     fontSize="inherit" 
      //                     sx={{ color: blue[700] }}  
      //                 />
      //             </IconButton>
      //             <IconButton
      //                 disabled={row.status == "Close" || row.status == "Cancel" }
      //                 aria-label="delete"
      //                 size="large"
      //                 onClick={() => {
      //                     setSelectedDepartmentManagement(row);
      //                     setOpenDialog(true);
      //                 }}
      //             >
      //                 <DeleteIcon 
      //                     fontSize="inherit" 
      //                     sx={{ color: red[500] }}
      //                 />
      //             </IconButton>
      //         </Stack>
      //       ),
      // },
  ];

  //search
  const [searchText, setSearchText] = React.useState("");
  const [searchText1, setSearchText1] = React.useState("");
  const [tableData, setTableData] = React.useState<any[]>([]);

  React.useEffect(() => {
      let  dataList:any[] = [];
      let index = 0;
      DepartmentManagementStateReducer.result.forEach((item) =>{
          dataList[index] = item;
          index += 1;
      })
      setTableData(dataList)
  }, [DepartmentManagementStateReducer.result]);

  const requestSearch = (searchValue: string) => {
      // const searchRegex = new RegExp(`.*${searchValue}.*`, "ig");
      // const filteredRows = DepartmentManagementStateReducer.result.filter((o: any) => {
      //   return Object.keys(o).some((k: any) => {
      //     return searchRegex.test(o[k].toString());
      //   });
      // });
      const filteredRows = DepartmentManagementStateReducer.result.filter((row) => {
        return row.name?.toString().toLowerCase().includes(searchValue.toLowerCase());
      });
      setTableData(filteredRows);
  };

  // const cancelSearch = () => {
  //     setSearchText("");
  //     requestSearch(searchText);
  // };
  const handleDeleteConfirm = (Department_Management_id:number) => {
      dispatch(DepartmentManagementActions.deleteDepartmentManagement(Department_Management_id,navigate));
      setOpenDialog(false);
  };



  const showDialog = () => {
      if (selectedDepartmentManagement === null) {
          return "";
      }
  return (
      <Dialog
      fullWidth
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          keepMounted
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
      >
          <DialogTitle id="alert-dialog-slide-title">
            {t("Delete Data")}
             
          </DialogTitle>
          <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">  {t("Confirm Delete Data")} : {selectedDepartmentManagement.name}</DialogContentText>
          </DialogContent>
          <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color="info">
              ยกเลิก
          </Button>
          <Button onClick={() => handleDeleteConfirm(selectedDepartmentManagement.id)} color="primary">
              ยืนยัน
          </Button>
          </DialogActions>
      </Dialog>
      );
  };

  const showDialogAddDepartmentManagement = () => {
   
return (
  <Dialog
  disableScrollLock
  fullWidth
  open={openaddDepartmentManagement}
  onClose={handleCloseaddDepartmentManagement}
  aria-labelledby="alert-dialog-title"
  aria-describedby="alert-dialog-description"
>
<form onSubmit={handleAddDepartmentManagementSubmit}>
  <DialogTitle id="alert-dialog-title" >
  {t("Add Department")} 
  </DialogTitle>
  <DialogContent>
    <DialogContentText id="alert-dialog-description">
    </DialogContentText>
    <Grid container  >
                    <Grid 
                    sx={{alignSelf:"center"}}
                    item xs={12}
                    sm={4}
                    md={4}
                    lg={4}
                    xl={4}>
    <Typography  variant="inherit"  component="h6">
{t('Department Name')} :
</Typography>
</Grid>
<Grid item xs={12}
                    sm={8}
                    md={8}
                    lg={8}
                    xl={8}>
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          id="email_address"
          size="small"
          onChange={(e) => {
                setdataAddDepartmentManagement({...dataAddDepartmentManagement,name:e.target.value});
          
           
          }}
          value={dataAddDepartmentManagement.name}
        />
         </Grid>
       </Grid>
     
  </DialogContent>
  <DialogActions>
    <Button onClick={handleCloseaddDepartmentManagement}> {t("Cancel")} </Button>
    <Button type="submit" autoFocus>
    {t("Save")} 
    </Button>
  </DialogActions>
  </form>
</Dialog>
    );
};

const showDialogEditDepartmentManagement = () => {
   
    return (
      <Dialog
      disableScrollLock
      fullWidth
      open={openeditDepartmentManagement}
      onClose={handleCloseeditDepartmentManagement}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
    <form onSubmit={handleEditDepartmentManagementSubmit}>
      <DialogTitle id="alert-dialog-title">
      {t("Edit Department")} 
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
        </DialogContentText>
        <Grid container  >
                        <Grid 
                        sx={{alignSelf:"center"}}
                        item xs={12}
                        sm={4}
                        md={4}
                        lg={4}
                        xl={4}>
        <Typography  variant="inherit"  component="h6">
    {t('Department Name')} :
    </Typography>
    </Grid>
    
    <Grid item xs={12}
                        sm={8}
                        md={8}
                        lg={8}
                        xl={8}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email_address"
              size="small"
              onChange={(e) => {
                    setdataEditDepartmentManagement({...dataEditDepartmentManagement,name:e.target.value});
              
               
              }}
              value={dataEditDepartmentManagement.name}
            />
             </Grid>
             </Grid>

      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseeditDepartmentManagement}> {t("Cancel")} </Button>
        <Button type="submit" autoFocus>
        {t("Save")} 
        </Button>
      </DialogActions>
      </form>
    </Dialog>
        );
    };

  return (
    <Container fixed sx={{ mt: 3}} >
      <Box 
      sx={{}}
     >
          {/* Summary Icons */}
          <Grid 
          container item
          justifyContent="center"
          alignItems="center"
          sx={{
              margin: 'auto',
              width: '100%',
              maxWidth: '60rem'
          }}
          ><Typography variant="body1">{t(`Department Management Page`)}</Typography>

          </Grid>

          {/* <Grid container justifyContent="flex-end">
              <Button 
                  size="medium"
                  variant="contained" 
                  sx={{
                      marginTop: 2,
                      marginLeft:2,
                      marginRight: 2,
                      minWidth: 200,
                      backgroundColor: "#c79059"
                  }}
                  className="requestButton"
                  onClick={() => { handleAddDepartmentManagement()}}
              >
                  {t("Add Department")} 
              </Button>
          </Grid> */}
          <br />
          <Grid>
          <Grid container spacing={2}>
 
  <Grid item xs={12}
                sm={6}
                md={6}
                lg={6}
                xl={6}>
   <TextField 
   fullWidth 
                  placeholder="ค้นหา..."
                  variant="outlined"
                  size="small"
                  InputProps={{
                      endAdornment: (<IconButton><SearchIcon /></IconButton>)
                  }}
                  onChange={(e)=>{
                      requestSearch(e.target.value)
                      setSearchText(e.target.value)
                  }} 
                  sx={{
                      //  width:500,
                      "& .MuiInput-underline:before": {
                          borderBottom: 1,
                          borderColor: "divider",
                      },
                      marginBottom:2
                  }}
              />
  </Grid>
  <Grid item xs={12}
                sm={6}
                md={6}
                lg={6}
                xl={6}>
  </Grid>
</Grid>
              
              <DataGrid
                  // components={{ Toolbar: CustomToolbar }}
                  sx={{ backgroundColor: "white"}}  
                  rows={tableData}
                  columns={requestColumns}
                  // componentsProps={{
                  //     toolbar: {
                  //       value: searchText,
                  //       onChange: (searchVal: string) => requestSearch(searchVal),
                  //       onCancelSearch: () => cancelSearch()
                  //     }
                  // }}
                  autoHeight
                  pageSize={10}
                  rowsPerPageOptions={[10]}
              />
          </Grid>
          <br />
          <br />
          {showDialog()}
          {showDialogAddDepartmentManagement()}
          {showDialogEditDepartmentManagement()}
      </Box>
      </Container>
);
                }
export default DepartmentManagement;
